import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

export const admin: Routes = [
  {
    path: "curve-di-carico",
    children: [
        {
            path: 'clienti',
            loadComponent: () => 
                import('./clienti/clienti.component').then((m) => m.ClientiComponent),
        }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class CurveDiCaricoRoutingModule {
  static routes = admin;
}
